<template>
    <div class="flow_chart">
        <div class="container">
            <div class="flow_chart_box">
                <div :style="{width:(100/(data.length)) + '%'}" v-for="(item,index) in data"
                     class="flow_chart_box_item">
                    <div>
                        <img :style="{width: boxWidth,height:boxHeight}" class="flow_chart_box_item_img_icon"
                             :src="item.icon"
                             :alt="item.title">
                        <div class="flow_chart_box_item_circle"></div>
                        <div class="flow_chart_box_item_title">{{ item.title }}</div>
                        <div v-if="item.desc && item.desc!='' " class="flow_chart_box_item_desc">
                            <p v-for="(item2,index2) in item.desc">{{ item2 }}</p>
                        </div>
                    </div>

                    <div v-if="index!= data.length-1" :style="{height: boxHeight}" class="flow_chart_box_item_arrow">
                        <img class="flow_chart_box_item_arrow_img"
                             src="../vipClip/threeSyndromesActivity/images/apply_register_arrow.png" alt="箭头">
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "flow-chart",
        props: {
            data: {
                type: Array,
                default: []
            },
            boxWidth: {
                type: String,
                default: '245px'
            },
            boxHeight: {
                type: String,
                default: '100px'
            }
        }
    }
</script>

<style scoped lang="less">
    .flow_chart {
        .container {
            width: 1334px;
            margin: 0 auto;
        }

        .flow_chart_box {
            display: flex;
            justify-content: space-between;

            .flow_chart_box_item {
                text-align: center;
                justify-content: space-around;
                display: flex;


                .flow_chart_box_item_img_icon {
                    display: block;
                    width: 245px;
                    height: 100px;
                }

                .flow_chart_box_item_circle {
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    background: #D8D8D8;
                    margin: 20px auto 0;
                }

                .flow_chart_box_item_title {
                    color: #282828;
                    font-size: 20px;
                    line-height: 28px;
                    padding-top: 16px;
                }

                .flow_chart_box_item_desc {
                    padding-top: 16px;
                    color: #666666;
                    font-size: 14px;
                    line-height: 20px;
                }


                &:last-child {
                    margin-right: 0;

                    .flow_chart_box_item_img {
                        &:after {
                            content: '';
                            display: none;
                        }
                    }
                }

            }


            .flow_chart_box_item_arrow {
                display: flex;
                align-items: center;

                .flow_chart_box_item_arrow_img {
                    display: block;
                    width: 24px;
                    height: 13px;

                }
            }
        }
    }

</style>